/*!
 * Created by netlogix GmbH & Co. KG
 *
 * @copyright netlogix GmbH & Co. KG
 */

import { ConstructionSitesState } from '@construction-sites/store/construction-sites.state';
import { createFeatureSelector, createSelector } from '@ngrx/store';

const selectConstructionSitesState = createFeatureSelector<ConstructionSitesState>('constructionSites');

export const getIsActionPending = createSelector(selectConstructionSitesState, state => state.isActionPending);
export const getConstructionSites = createSelector(selectConstructionSitesState, state => state.constructionSites);
export const getCurrentConstructionSite = createSelector(selectConstructionSitesState, state => state.currentConstructionSite);
export const getTourFilter = createSelector(selectConstructionSitesState, state => state.tourFilter);
export const getTourFilterDate = createSelector(selectConstructionSitesState, state => state.tourFilter?.date);
export const getTours = createSelector(selectConstructionSitesState, state => state.tours);
export const getConstructionSiteActionPending = createSelector(selectConstructionSitesState, state => state.actionPending);
